import { createSelector } from '@ngrx/store';
import { selectPageHeaderState } from '../reducers';

export const selectShowClientSelector = createSelector(
  selectPageHeaderState,
  (state) => state.showClientSelection,
);
